import { createStore } from "jotai";

export const jotaiStore = createStore();
